"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const composeSerializers = (...serializers) => {
  return (...args) => {
    for (let i = 0; i < serializers.length; i++) {
      const serializer = serializers[i];
      if (serializer) {
        const res = serializer(...args);
        if (res != null) {
          return res;
        }
      }
    }
  };
};
exports.composeSerializers = composeSerializers;
//# sourceMappingURL=composeSerializers.cjs.map
